import { Select } from "@radix-ui/react-select";
import { useRouter } from "next/router";
import { useI18nContext } from "~/i18n/i18n-react";
import type { Locales } from "~/i18n/i18n-types";
import {
	SelectContent,
	SelectItem,
	SelectTrigger,
	SelectValue,
} from "../ui/select";

const LanguageSelect = () => {
	const { locale: nextLocale, asPath, push } = useRouter();
	const defaultLocale =
		typeof window !== "undefined"
			? (localStorage.getItem("language") ?? "en")
			: "en";
	const locale = (defaultLocale ?? nextLocale) as Locales;
	const { LL, setLocale } = useI18nContext();

	const onLanguageSwitched = async (
		locale: "en" | "ar" | "es" | "ca" | "pt" | "ee" | "ru" | "mt" | "tl",
	) => {
		console.log(`[Language Switched to ${locale}]`);
		// change just the locale and maintain all other route information including href's query
		setLocale(locale);
		localStorage.setItem("language", locale);
		await push(asPath, asPath, { locale });
	};

	return (
		<Select
			onValueChange={(
				language: "en" | "ar" | "es" | "ca" | "pt" | "ee" | "ru" | "mt" | "tl",
			) => onLanguageSwitched(language)}
			defaultValue={locale}
		>
			<SelectTrigger>
				<SelectValue placeholder={LL.CREATE_ROOM_FORM.LANGUAGE_PLACEHOLDER()} />
			</SelectTrigger>
			<SelectContent>
				<SelectItem value="en">English (United States)</SelectItem>
				<SelectItem value="ar">العربية (السعودية)</SelectItem>
				<SelectItem value="es">Español (Costa Rica)</SelectItem>
				<SelectItem value="ca">Català (Espanya)</SelectItem>
				<SelectItem value="pt">Português (Portugal)</SelectItem>
				<SelectItem value="ee">Eesti (Eesti)</SelectItem>
				<SelectItem value="ru">Русский (Россия)</SelectItem>
				<SelectItem value="mt">Malti (Malta)</SelectItem>
				<SelectItem value="tl">Filipino (Pilipinas)</SelectItem>
			</SelectContent>
		</Select>
	);
};

export default LanguageSelect;
